import styled from '@emotion/styled';
import { SmallText } from 'ds/components/typography';


export const ListTitle = styled(SmallText.withComponent('h1'))<{ isOnIndexPage: boolean }>`
  ${({ theme }) => `
    color: ${theme.colors.neutrals.grey3};
    margin: ${theme.spacing(2)} 0;
  `}
  ${({ theme, isOnIndexPage }) => theme.media.showAt({ from: 3 })`
    margin: ${theme.spacing(isOnIndexPage ? 2 : 3)} 0;
  `}
`;

export const ListWrapper = styled.div`
  ${({ theme }) => `
    margin: 0 -${theme.spacing(1.5)};
  `}
  ${({ theme }) => theme.media.showAt({ from: 2 })`
    display: flex;
    flex-wrap: wrap;
  `}
  ${({ theme }) => theme.media.showAt({ at: 2 })`
    width: 628px;
    margin: 0 auto;
  `}
`;

export const HeaderWrapper = styled.div`
  position: sticky;
  top: 0;
  z-index: 2;

  > div > div {
    border-bottom: none;
  }
`;
